const APIS = {
  DEFAULT_BRANCH: "/branch/default-branch/",
  SERVICE_TYPE: "/logisticservice/api/service-type/",
  DRAFT_ORDER: "/pickuprequestservice/api/order/draft-orders/",
  PICKUPREQUEST: "/pickuprequestservice/api/pickup-request/",
  BRANCH: "/logisticservice/api/branch/",
  DRIVER: "/fleetservice/api/driver/",
  USER: "/usermanagementservice/api/user/",
  VEHICLE: "fleetservice/api/vehicle/",
  REMARK: "/logisticservice/api/remark/",
  COMMENT: "/commentservice/api/comment/",
  RECEIVER_DETAIL: "/logisticservice/api/receiver-detail/",
  INVOICE: "/invoiceservice/api/merchant-invoice/invoice-id/",
  ORDER_HISTORY: "/historyservice/api/history/",
  PICKUPREQUEST_ITEMS: "/pickuprequestservice/api/pickup-request-item/",
  ORDER: "/logisticservice/api/order/",
  WEBSITE: "/get-website/",
  LOCATION: "/logisticservice/api/location/",
  RUNSHEET: "/runsheetservice/api/runsheet/order-runsheet/",
  RTV: "/rtvorderservice/api/rtv-order/order-rtv/",
  PERMISSION: "/permission/",
  DRIVER_CREATE: "/fleetservice/api/driver/create-rider/",
};

export default APIS;
